export const translate =
    {
        news:{"RU":"Новости", "KG":"Жаңылыктар", "EN":"News"},
        services:{"RU":"Услуги","KG":"Тейлөө","EN":"Services"},
        projects:{"RU":"Проекты","KG":"Долбоорлор","EN":"Projects"},
        contacts:{"RU":"Контакты","KG":"Байланыштар","EN":"Contacts"},
        loadMore:{"RU":"Загрузить еще","KG":"Көбүрөөк жүктөө","EN":"Load more"},
        wordDays:{"RU":"Рабочие дни","KG":"Жумуш күндөрү","EN":"Work days"},
        location:{"RU":"Расположение","KG":"Жайгашкан жер","EN":"Location"},
        send:{"RU":"Отправить","KG":"Жөнөтүү","EN":"Send"},
        investors:{"RU":"Инвесторы","KG":"Инвесторлор","EN":"Investors"},
        aboutCompany:{"RU":"О компании","KG":"Компания жөнүндө","EN":"About the company"},
        boezgrt:{"RU":"БОЭЗГРТ","KG":"БОЭЗГРТ","EN":"BOEZGRT"},
        vacancies:{'RU':"Вакансии","KG":"","EN":"Vacancies"},
        days:{
                monday:{"RU":"Понедельник","KG":"Дүйшөмбү","EN":"Monday"},
                tuesday:{"RU":"Вторник","KG":"Шейшемби","EN":"Tuesday"},
                wednesday:{"RU":"Среда","KG":"Шаршемби","EN":"Wednesday"},
                thursday:{"RU":"Четверг","KG":"Бейшемби","EN":"Thursday"},
                friday:{"RU":"Пятница","KG":"Жума","EN":"Friday"},
                saturday:{"RU":"Суббота","KG":"Ишенби","EN":"Saturday"},
                sunday:{"RU":"Воскресенье","KG":"Жекшемби","EN":"Sunday"}
        },
        weekend:{"RU":"Выходной день","KG":"Дем алыш күн","EN":"Weekend"},
        mainAddress:{"RU":"г. Бишкек, ул. Эркиндик 2","KG":"Бишкек ш.,Эркиндик 2 к.","EN":"Bishkek, Erkindik 2"},
        phoneNumber:{"RU":"Номер телефона","KG":"Телефон номуру","EN":"Phone number"},
        geologicalExploration:{"RU":"Геологоразведка","KG":"Геологиялык чалгындоо","EN":"Geological Exploration"},
        resources:{
                gold:{"RU":"Золото","KG":"Алтын","EN":"Gold"},
                coal:{"RU":"Уголь","KG":"Көмүр","EN":"Coal"},
                looseGold:{"RU":"Рассыпное золото","KG":"Бош алтын","EN":"Loose gold"},
                hardCoal:{"RU":"Каменный уголь","KG":"Таш Көмүр","EN":"Hard coal"},
                marbledLimestone:{"RU":"Мраморизованный известняк","KG":"Мраморлуу акиташ","EN":"Marbled limestone"},
                antimonyFluorite:{"RU":"Сурьма, флюорит","KG":"Сурьма, флюорит","EN":"Antimony, fluorite"},
                gypsum:{"RU":"Гипс","KG":"Гипс","EN":"Gypsum"},
                clayShales:{"RU":"Глинистые сланцы","KG":"Глинистые сланцы","EN":"Clay shales"},
                granite:{"RU":"Гранит","KG":"Гранит","EN":"Granite"},
                shellRock:{"RU":"Ракушечник","KG":"Ракушечник","EN":"Shell Rock"},
                iron:{"RU":"Железо","KG":"Темир","EN":"Iron"},
                limestoneShellRock:{"RU":"Известняк ракушечник","KG":"Акиташ ракушечник","EN":"Limestone shell rock"},
                kaolin:{"RU":"Каолин","KG":"Каолин","EN":"Kaolin"},
                rareEarthMetals:{"RU":"Редкоземельные металлы","KG":"","EN":"Rare earth metals"},
        },
        translatedApi:{
                title:{"RU":"title_ru","KG":"title_ky","EN":"title_en"},
                body:{"RU":"body_ru","KG":"body_ky","EN":"body_en"},
                name:{"RU":"name_ru","KG":"name_ky","EN":"name_en"},
                post:{"RU":"post_ru","KG":"post_ky","EN":"post_en"},
                category:{"RU":"category_ru","KG":"category_ky","EN":"category_en"},
                month:{"RU":"month_ru","KG":"month_ky","EN":"month_en"}
        },
        comments:{"RU":"Комментарии","KG":"Комментарийлер","EN":"Comments"},
        noComments:{"RU":"Комментариев нет","KG":"Комментарийлер жок","EN":"There are no comments"},
        noNews:{"RU":"Новостей нет","KG":"Жаңылык жок","EN":"There are no news"},
        noServices:{"RU":"Услуг нет","KG":"Кызматтар жок","EN":"There are no services"},
        noData:{"RU":"Данных нет","KG":"Маалымат жок","EN":"There are no data"},
        noVacancies:{"RU":"Вакансий нет","KG":"","EN":"There are no vacancies"},
        history:{"RU":"История и миссия предприятия","KG":"Ишкананын тарыхы жана миссиясы","EN":"The history and mission of the company"},
        achievements:{"RU":"Достижения","KG":"Жетишкендиктер","EN":"Achievements"},
        kyrgyzgeology:{"RU":"Кыргызгеология","KG":"Кыргызгеология","EN":"Kyrgyzgeology"},
        ourAddress:{"RU":"Наш адрес","KG":"Биздин дарек","EN":"Our address"},
        main:{"RU":"Главная","KG":"Жалпы","EN":"Main"},
        viewPdf:{"RU":"Прикрепленный файл","KG":"","EN":"Attached file"},
        income:{"RU":"Доход","KG":"Киреше","EN":"Income"},
        diagramOfAll:{"RU":"Диаграма всех объектов","KG":"Бардык объекттердин диаграммасы","EN":"Diagram of all objects"},
        graphOfMonth:{"RU":"График месячного дохода","KG":"Айлык киреше диаграммасы","EN":"Monthly income graph"},
        numberOfDeposits:{"RU":"Количество месторождений","KG":"Кендүү жерлер","EN":"Number of deposits"},
            apiCurrency :{
                    usd: {
                            api: "price_dollar",
                            currency: '$'
                    },
                    eur: {
                            api: "price_euro",
                            currency: '€'
                    },
                    rub: {
                            api: "price_rubles",
                            currency: '₽'
                    },
                    kzt: {
                            api: "price_tenge",
                            currency: '₸'
                    },
                    kgs: {
                            api: "price",
                            currency: 'C'
                    },
            }
    }